declare global {
  interface Window {
    AudioContext: AudioContext;
    webkitAudioContext: AudioContext;
  }
}

const AudioContextPolyfill: typeof window.AudioContext | undefined =
  typeof window !== 'undefined' ? window.AudioContext || window.webkitAudioContext : undefined;

export const AudioContext = AudioContextPolyfill;
